import { Radio, RadioChangeEvent } from 'antd';
import { CheckboxOptionType } from 'antd/lib/checkbox/Group';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SpacingRow, SpacingUnit } from 'components/ui';
import { FillingMethod } from 'entities/FormField';
import { isDataTypeWithoutFillingMethod } from 'stores/local/forms/models';

import { ColumnBaseProps } from '../types';

const FillingMethodColumn: React.FC<ColumnBaseProps> = ({ record }) => {
  const { t } = useTranslation();

  const options: CheckboxOptionType[] = React.useMemo(
    () => [
      { label: t('fillingMethod.import'), value: FillingMethod.import },
      { label: t('fillingMethod.form'), value: FillingMethod.form },
    ],
    [t]
  );

  const onChange = React.useCallback(
    (e: RadioChangeEvent) => {
      record.formField.setFillingMethod(e.target.value);
    },
    [record]
  );

  if (isDataTypeWithoutFillingMethod(record.formField)) {
    return null;
  }

  return (
    <SpacingRow hSpacing={SpacingUnit.none}>
      <Radio.Group
        onChange={onChange}
        options={options}
        value={record.formField.fillingMethod}
        optionType="button"
        buttonStyle="outline"
      />
    </SpacingRow>
  );
};

export default observer(FillingMethodColumn);
